import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TagsComponent } from './tags.component';

@NgModule({
  declarations: [TagsComponent],
  exports: [TagsComponent],
  imports: [CommonModule],
})
export class TagsComponentModule {}
